import type { AgreementExtractSummary } from '@erp/rpc';
import { rpcClient } from '@/api/rpc/client';
import { stageUpload } from './stageUpload';

export async function uploadAgreementExtract(
  file: File,
  onUploadProgress?: (percent: number | null) => void,
): Promise<AgreementExtractSummary> {
  const uploadKey = await stageUpload({
    file,
    contentType: 'text/csv',
    getUploadUrl: rpcClient.pricing.agreementExtract.getUploadUrl,
    onUploadProgress,
  });
  onUploadProgress?.(null);
  return rpcClient.pricing.agreementExtract.confirmUpload({
    uploadKey,
    fileName: file.name,
  });
}
